import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';

const Table: React.FC<{
  domains: Domain[];
  searchQuery: string;
  parentDomain: string;
  selectDomain: (domain: Domain) => void;
}> = ({ domains, searchQuery, parentDomain, selectDomain }) => {
  return (
    <Box sx={{ mt: 2, height: '60vh', padding: 2 }}>
      {domains.length > 0 ? (
        <List sx={{ height: '75%', overflow: 'auto' }}>
          {domains.map((domain, index) => (
            <ListItem
              key={index}
              sx={{
                borderBottom:
                  domains.length > 1 && index < domains.length - 1
                    ? '1px solid #475569'
                    : 'none',
                cursor: 'pointer',
              }}
              onClick={() => selectDomain(domain)}
            >
              <ListItemText
                data-cy={`sub-list-domain-name-${index}`}
                primary={domain?.name}
              />
              <Typography>{domain.accessRights}</Typography>
            </ListItem>
          ))}
        </List>
      ) : searchQuery.length === 0 ? (
        <Typography align="center" variant="h6">
          No domains registered yet
        </Typography>
      ) : (
        <Typography align="center" variant="h6">
          You do not have
          <span
            style={{
              color: '#66C9E8',
              paddingLeft: '3px',
              paddingRight: '3px',
            }}
          >
            {` ${searchQuery}.${parentDomain} `}
          </span>
          registered yet.
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(Table);
